import {FC, useState} from 'react'
import {ID, KTSVG} from '../_metronic/helpers'

export const RatingComponent: FC<{
  value: number
  setValue: (val: number) => void
  id?: ID
}> = ({value, setValue, id}) => {
  const [rating, setRating1] = useState(value.toString())
  const setRating = (val: string) => {
    setRating1(val)
    setValue(Number(val))
  }
  return (
    <div className='rating'>
      {/* <label
          className='btn btn-light fw-bolder btn-sm rating-label me-3'
          htmlFor={`kt_rating_${id||0}_input_0`}
        >
          Reset
        </label> */}
      <input
        className='rating-input'
        name={'rating' + id || ''}
        value='0'
        checked={rating === '0'}
        onChange={() => {}}
        type='radio'
        id={`kt_rating_${id || 0}_input_0`}
      />

      {Array.from(Array(5)).map((v, i) => (
        <>
          <label className='rating-label' htmlFor={`kt_rating_${id || 0}_input_${i + 1}`}>
            <KTSVG path='/media/icons/duotune/general/gen029.svg' className='svg-icon svg-icon-1' />
          </label>
          <input
            className='rating-input'
            name={'rating' + id || ''}
            value={`${i + 1}`}
            checked={rating === `${i + 1}`}
            onChange={() => setRating(`${i + 1}`)}
            type='radio'
            id={`kt_rating_${id || 0}_input_${i + 1}`}
          />
        </>
      ))}
    </div>
  )
}
export const StaticRating: FC<{value: number}> = ({value}) => {
  return (
    <div className='rating'>
      {Array.from(Array(5)).map((i, id) => (
        <div key={id} className={`rating-label ${id < value ? 'checked' : ''}`}>
          <KTSVG path='/media/icons/duotune/general/gen029.svg' className='svg-icon svg-icon-1' />
        </div>
      ))}
    </div>
  )
}
